import { ItemListSkeletonRow } from "./rows/variants/item-list-skeleton-row";
import { css } from "@/domains/emotion";
import { ItemListSkeletonRowData, ItemListRowType } from "@/components/item-list/types";

export const ItemListSkeleton = () => {
  const data: ItemListSkeletonRowData = {
    key: "skeleton",
    type: ItemListRowType.Skeleton,
    payload: {},
  };

  return (
    <div className={skeletonStyles}>
      {Array.from({ length: 10 }).map((_, i) => (
        <ItemListSkeletonRow data={data} key={i} />
      ))}
    </div>
  );
};

const skeletonStyles = css({
  margin: `40px 10px`,
  overflowY: "hidden",
});
